module.exports = __webpack_public_path__ + "img/bruxelles_oro_2019.b20ccd80.jpeg";